import { Group, Text } from '@mantine/core'
import { HolidayCalendarParams } from 'app/models/holiday-calendar-params'
import MainTable from 'app/views/components/Table/MainTable'
import { gridHolidaySummaryColumnDefs } from './grid-holiday-summary-columnDefs'
import { ReactComponent as CloseIcon } from 'app/public/DrawerIcons/close-icon.svg'

interface Props {
  calendar: HolidayCalendarParams
  clearCalendar: () => void
}

export function HolidayCalendarSummaryAccordion({ calendar, clearCalendar }: Props) {

  return (
    <div className='holiday-calendar-summary-box'>
      <Group w="100%" position="apart">
        <Text className='holiday-calendar-grid-summary-title'>Summary</Text>
        <CloseIcon style={{ width: '30px', cursor: "pointer" }} onClick={clearCalendar} />
      </Group>
      <Text className='hloday-calendar-grid-summary-subtitle'>{calendar.name}</Text>
      <MainTable
        tableName="Holiday Calendar Summary"
        stretch={true}
        columnDefs={gridHolidaySummaryColumnDefs}
        data={calendar.holidayInfo ?? []}
        setRow={() => { }}
        headerBackgroundColor="#F0EEEE"
        enableColumnActions={false}
        enableTopToolbar={false}
        withPagination={true}
        csvExportEnabled={false}
        enableColumnResizing={false}
        enableColumnOrdering={false}
        enableFilters={false}
        enableSorting={false}
        enableGrouping={false}
        minHeight="0px"
        isLoading={false}
        border={true}
      />
    </div >
  )
}
